export enum ColumnEditState {
    NONE,
    EDITING,
    SAVING,
    FAIL,
    DONE
}
export enum ColumnEditState {
    NONE,
    EDITING,
    SAVING,
    FAIL,
    DONE
}
